import { writable } from 'svelte/store'

// import * as Sentry from '@sentry/sveltekit'
import { parseInvoiceList } from '$lib/parsers'
import { apiPostJson } from '$lib/proxy/apiProxy'
import type { InvoiceListItem } from '$lib/stores/invoices/types'

import type { InvoicesParams } from './types'

// const emptyParameters = {
// 	statuses: [] as InvoiceStatus[],
// 	archived: [false],
// 	invoices_filter: '',
// 	query: '',
// 	clientId: ''
// }

// export const invoicesParameters = writable({ ...emptyParameters })
export const invoices = writable([] as InvoiceListItem[])


let controller: AbortController | null


export const resetInvoices = () => {
	invoices.set([])
	// invoicesParameters.set({ ...emptyParameters })
}


export async function InitInvoices(params: InvoicesParams){
	const data = await getInvoices(params)
	if (data) invoices.set(data)
}


export async function getInvoices(params: InvoicesParams){
	//console.log('invoices parameters', parameters);

	if (controller) {
		controller.abort()
	}

	controller = new AbortController()
	const signal = controller.signal

	const jsonData = await apiPostJson(
		'/invoices',
		{
			statuses: params.statuses,
			archived: params.archived,
			invoices_filter: params.invoices_filter,
			query: params.query,
			client_id: params.clientId,
			item_id: params.itemId,
			invoice_id: params.invoiceId,
			date_start: params.date_start,
			date_end: params.date_end
		},
		signal
	)
	controller = null

	// Check if cancelled by AbortController
	if (jsonData === null) return null
	if (jsonData?.error) {
		return []
	}

	const data = parseInvoiceList(jsonData.invoices)
	return data
}
